import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { LangProvider } from "@/lib/i18n";
import { setLenis } from "@/lib/scroll";
import { enableCopyProtection } from "@/lib/protect";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Region } from "@/components/site/Region";
import { Bento } from "@/components/site/Bento";
import { UseCases } from "@/components/site/UseCases";
import { Steps } from "@/components/site/Steps";
import { Economics } from "@/components/site/Economics";
import { Warranty } from "@/components/site/Warranty";
import { Faq } from "@/components/site/Faq";
import { Contacts } from "@/components/site/Contacts";
import { NetworkMap } from "@/components/site/NetworkMap";
import { Footer } from "@/components/site/Footer";
import { BackgroundMusic } from "@/components/site/BackgroundMusic";

const Admin = lazy(() => import("@/pages/Admin"));

function Site() {
  useEffect(() => enableCopyProtection(), []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let id;
    const raf = (time) => {
      lenis.raf(time);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <LangProvider>
      <div className="site">
        <div className="grain" aria-hidden="true" />
        <Header />
        <main>
          <Hero />
          <Marquee />
          <About />
          <Region />
          <Bento />
          <UseCases />
          <Steps />
          <Economics />
          <Warranty />
          <Faq />
          <Contacts />
          <NetworkMap />
        </main>
        <Footer />
        <BackgroundMusic />
        <Toaster position="bottom-center" theme="dark" richColors />
      </div>
    </LangProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<Suspense fallback={null}><Admin /></Suspense>} />
        <Route path="*" element={<Site />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
